import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppAuthGuard } from './core/guards/app-auth-guard';
import { AppInternalSupportGuard } from './core/guards/app-internal-support-guard';
import { FaqGuard } from './core/guards/faq-guard';
import { environment } from '@env/environment';

const routes: Routes = [
  {
    path: 'activities',
    canActivate: [AppAuthGuard],
    loadChildren: () => import('./modules/activity/activity.module').then(mod => mod.ActivityModule)
  },
  {
    path: 'requests',
    canActivate: [AppAuthGuard, AppInternalSupportGuard],
    loadChildren: () => import('./modules/customerrequests/customerrequests.module').then(mod => mod.CustomerRequestsModule)
  },
  {
    path: 'payments',
    canActivate: [AppAuthGuard],
    loadChildren: () => import('./modules/payments/payments.module').then(mod => mod.PaymentsModule)
  },
  {
    path: 'supports',
    canActivate: [AppAuthGuard],
    loadChildren: () => import('./modules/supports/supports.module').then(mod => mod.SupportsModule)
  },
  {
    path: 'users',
    canActivate: [AppAuthGuard],
    loadChildren: () => import('./modules/user/user.module').then(mod => mod.UserModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./modules/maintenance/maintenance.module').then(mod => mod.MaintenanceModule)
  },
  { path: '', redirectTo: 'activities', pathMatch: 'full' },
];

const menuFaqUrl = environment.passenger.application.faq.menuExternalUrl;
const footerFaqUrl = environment.passenger.application.faq.externalUrl;

if ((!menuFaqUrl || menuFaqUrl === 'faq') || (!footerFaqUrl || footerFaqUrl === 'faq')) {
  routes.push({
    path: 'faq',
    canActivate: [AppAuthGuard, FaqGuard],
    loadChildren: () => import('./modules/faq/faq.module').then(mod => mod.FaqModule)
  });
}

if (!environment.passenger.application.footer.cgu.externalUrl || environment.passenger.application.footer.cgu.externalUrl === 'cgu') {
  routes.push({
    path: 'cgu',
    loadChildren: () => import('./modules/cgu/cgu.module').then(mod => mod.CguModule)
  });
}

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
